import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export const TAG_VARIANTS = {
  NEUTRAL: 'neutral',
  AI_CONTENT: 'aiContent',
  AI_IMAGE: 'aiImage',
  TIME: 'time',
} as const;

export type TagVariant = (typeof TAG_VARIANTS)[keyof typeof TAG_VARIANTS];

@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagComponent {
  readonly label = input.required<string>();
  readonly variant = input<TagVariant>(TAG_VARIANTS.NEUTRAL);
}
